export default "/images/0318075f21066ef213ec1a03eff6d091.avif";